module.exports = __webpack_public_path__ + "ff8e08a835295163c759d5e0ba75912c.svg";